import { GetEventDivisionQuery } from "graphql/eventDivision.types";
import { DivisionToSeasons } from "graphql/generated/types";
import { EventModel } from "models/Event";

export type EventDivisionModel = ReturnType<typeof EventDivision>;

export const EventDivision = (
    eventDivisionData: GetEventDivisionQuery["eventDivision"] & {
        divisionToSeasons?: DivisionToSeasons[] | null;
    },
) => ({
    ...eventDivisionData,
    hasRankingsEnabled(event: EventModel) {
        const rankingsSeries = event.rankingsSeries();
        const ownSeries = rankingsSeries.filter(
            (series) => series.organisationId === event.organisationId,
        );
        const parentRankings = rankingsSeries.filter(
            (series) => series.organisationId !== event.organisationId,
        );
        return (
            ownSeries.length > 0 ||
            parentRankings.some((series) =>
                eventDivisionData.divisionToSeasons?.find(
                    (divisionToSeason) =>
                        divisionToSeason.seasonId === series.id,
                ),
            )
        );
    },
    isGroup() {
        return eventDivisionData.eventDivisions.length > 0;
    },
    isTeams() {
        return eventDivisionData.formatDefinition?.isTeams;
    },
});
